import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";
import { Button } from "components/common/Button";
import { SUGGESTION_PLANS_MAX } from "../constants";
import type { FolderSuggestionErrorBannerProps } from "./types";

export const FolderSuggestionErrorBanner = ({
  error,
  isLastResultKept,
  onRetry,
}: FolderSuggestionErrorBannerProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-shrink-0 items-center justify-between gap-3 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">
      <span className="flex items-center gap-2">
        <AlertCircle size={16} className="flex-shrink-0" />
        {error === "tooManyPlans"
          ? t("smartSurveyor.folders.suggestion.tooManyPlans", {
              count: SUGGESTION_PLANS_MAX,
            })
          : t("smartSurveyor.folders.suggestion.failed")}
        {isLastResultKept &&
          ` ${t("smartSurveyor.folders.suggestion.lastResultKept")}`}
      </span>
      {/* Retrying cannot lower the plan count. */}
      {error === "unavailable" && (
        <Button size="sm" variant="outline" onClick={onRetry}>
          {t("smartSurveyor.folders.suggestion.retry")}
        </Button>
      )}
    </div>
  );
};
